import { z } from 'zod'
import type { AnyEntityId, EntityId } from './Id'

export interface EntityWithId<Id extends EntityId<string> = AnyEntityId> {
  id: Id
}

/**
 * Interface representing an entity with standard audit fields.
 * Renamed from `AppEntity` to avoid naming conflicts with app-specific types.
 */
export interface EntityWithAuditFields<Id extends EntityId<string> = AnyEntityId> extends EntityWithId<Id> {
  createdBy?: string | null
  createdAt?: string | Date | null
  updatedBy?: string | null
  updatedAt?: string | Date | null
}

/**
 * Zod schema for standard audit fields (createdBy, createdAt, updatedBy, updatedAt)
 */
export const AppEntitySchema = z.object({
  createdBy: z.string().nullish(),
  createdAt: z.union([z.date(), z.iso.datetime({ offset: true })]).nullish(),
  updatedBy: z.string().nullish(),
  updatedAt: z.union([z.date(), z.iso.datetime({ offset: true })]).nullish(),
})

/**
 * Utility type to remove audit fields from an entity type
 */
export type OmitAuditFields<T> = Omit<T, 'createdBy' | 'createdAt' | 'updatedBy' | 'updatedAt'>

/**
 * Utility type for insert operations (removes id and audit fields)
 */
export type Insert<T> = Omit<OmitAuditFields<T>, 'id'>
